import React from 'react';
import './Footer.css';

// Note: Ensure you have FontAwesome or LineAwesome linked in your index.html 
// for the icons to appear, or install via npm.

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="custom-footer-wrapper">
      <div className="custom-footer-container">
        {/* Copyright Text */}
        <div className="custom-copyright-row">
          <p>Copyright © {currentYear}. All Rights Reserved</p>
        </div>
      </div>

      {/* Scroll to Top Button (Bottom Right) */}
      <button className="custom-scroll-top" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
        <i className="fas fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

export default Footer;